import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../../redux-toolkit/store/store";
import { formatDate } from "../../helpers/date";
import { socket } from "../../socketService";
import { getAuthToken } from "../../helpers/userDetails";
import {
  pushNewMessage,
  getChatByUserIdApi,
  updatePageToRequestMoreMessages,
} from "../../redux-toolkit/slices/chatSlice";

const ChatWindow = () => {
  const dispatch = useAppDispatch();
  const messagesEndRef = useRef<HTMLDivElement | null>(null);
  const messagesContainerRef = useRef<HTMLDivElement | null>(null); // Ref for scroll container

  const { selectedUser, userChat, incomingMessageCount } = useSelector(
    (state: RootState) => state.chat
  );
  const { userProfile } = useSelector((state: RootState) => state.auth);
  const [message, setMessage] = useState<string>("");
  const selectedUserId = selectedUser?.userId?._id || "";
  const getUser = (user: IChatMeta) => {
    return `${user.userId.firstName} ${user.userId.lastName}`;
  };
  const scrollToBottom = () => {
    setTimeout(() => {
      if (messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 0);
  };

  useEffect(() => {
    if (userChat.currentPage === 1) return;

    dispatch(
      getChatByUserIdApi({
        userId: selectedUserId,
        page: userChat.currentPage,
      })
    );
  }, [userChat.currentPage]);

  const handleScroll = () => {
    const container = messagesContainerRef.current;
    if (container && container.scrollTop === 0 && userChat.hasMore) {
      dispatch(updatePageToRequestMoreMessages());
    }
  };

  const sendMessage = (userId: string) => {
    if (message.trim() !== "") {
      socket.emit("sendMessageToUser", {
        userId,
        token: getAuthToken(),
        message: message,
      });

      dispatch(
        pushNewMessage({
          _id: Math.random().toString(),
          content: message,
          createdAt: new Date(),
          receiverId: "",
          senderId: userProfile?.id || "",
          isRead: false,
          updatedAt: new Date(),
        })
      );
      scrollToBottom();
      setMessage("");
    }
  };
  useEffect(() => {
    scrollToBottom();
  }, [incomingMessageCount]);
  // if (isSubmitting) {
  //   return <p>Loading</p>;
  // }
  console.log({ selectedUserId });
  return (
    <>
      <div className="chat-window">
        <div className="chat-header">
          <h3 className="messages-header-text">
            {selectedUser ? getUser(selectedUser) : "Select User To Chat"}
          </h3>
        </div>

        {/* Chat messages container with scroll */}
        <div
          className="chat-messages"
          ref={messagesContainerRef}
          onScroll={handleScroll} // Detect scroll
          style={{ overflowY: "auto", maxHeight: "400px" }}
        >
          {userChat.entries.map((msg, index) => (
            <div
              key={index}
              className={`message ${
                msg.senderId === selectedUserId ? "other" : "me"
              }`}
            >
              <p>{msg.content}</p>
              <p
                className={`${
                  msg.senderId === selectedUserId
                    ? "message-time"
                    : "message-time-me"
                }`}
              >
                {formatDate(msg.createdAt)}
              </p>
            </div>
          ))}
          <div ref={messagesEndRef} />
        </div>

        {/* Input and send button */}
        <div className="chat-input">
          <input
            onKeyDown={(e) => {
              if (e.key.toLowerCase() === "enter") {
                if (selectedUser) {
                  sendMessage(selectedUser.userId._id);
                }
              }
            }}
            disabled={!selectedUser}
            type="text"
            placeholder="Send a message..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <button
            onClick={(e) => {
              e.preventDefault();
              if (selectedUser) {
                sendMessage(selectedUser.userId._id);
              }
            }}
            disabled={!selectedUser}
          >
            📩
          </button>
        </div>
      </div>
    </>
  );
};

export default ChatWindow;
